// 路由：/phonics/ff
import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import { letterData } from './phonics/phonics_data_ff';

function PhonicsFf() {
  return <PhonicsAtoZ letterData={letterData} />;
}

export default PhonicsFf;
